import 'regenerator-runtime/runtime'; // חובה לאייפונים ישנים
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// --- תיקונים קריטיים לאייפון (Baking in the polyfills) ---

// 1. תיקון ל-globalThis
if (typeof globalThis === 'undefined') { window.globalThis = window; }

// 2. תיקון לדיאלוגים (באמצעות הספרייה שהתקנו)
import dialogPolyfill from 'dialog-polyfill';
import 'dialog-polyfill/dialog-polyfill.css';

if (typeof window.HTMLDialogElement === 'undefined') {
    window.HTMLDialogElement = dialogPolyfill;
}
// -------------------------------------------------------

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)